// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IChildRecordDto
 */
export interface IChildRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IChildRecordDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IChildRecordDto
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IChildRecordDto
     */
    main?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof IChildRecordDto
     */
    pages?: Array<number>;
}

/**
 * Check if a given object implements the IChildRecordDto interface.
 */
export function instanceOfIChildRecordDto(value: object): value is IChildRecordDto {
    return true;
}

export function IChildRecordDtoFromJSON(json: any): IChildRecordDto {
    return IChildRecordDtoFromJSONTyped(json, false);
}

export function IChildRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IChildRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'main': json['main'] == null ? undefined : json['main'],
        'pages': json['pages'] == null ? undefined : json['pages'],
    };
}

export function IChildRecordDtoToJSON(json: any): IChildRecordDto {
    return IChildRecordDtoToJSONTyped(json, false);
}

export function IChildRecordDtoToJSONTyped(value?: IChildRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'main': value['main'],
        'pages': value['pages'],
    };
}

